import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import useHub from "data/hub/useHub";

const isString = (s) => {
  return typeof s === "string" || s instanceof String;
};

export function useRedirect() {
  const hub = useHub();
  const history = useHistory();

  return useCallback(
    (path) => {
      if (!hub) return;

      const makePath = () => {
        const root = `/hub/${hub.hubId}`;

        if (!isString(path) || path === "") return root;
        const p = path.replace(`${root}/`, "");
        return `${root}/${p}`;
      };

      history.push(makePath());
    },
    [history, hub]
  );
}

export default useRedirect;
